import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=b35be8ee&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=b35be8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35be8ee",
  null
  
)

export default component.exports